import React from 'react';
import { Link } from 'react-router-dom';
import './CommonComponents.css';

/* ===== Page Banner (used on inner pages) ===== */
export const PageBanner = ({ title, subtitle, breadcrumbs = [], backgroundImage }) => (
  <section
    className="page-banner"
    style={backgroundImage ? { backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center" } : {}}
  >
    <div
      className="page-banner__overlay"
      style={backgroundImage ? { background: "linear-gradient(135deg, rgba(14,38,64,0.72), rgba(26,60,94,0.68))" } : {}}
    />
    <div className="container page-banner__content">
      <h1 className="page-banner__title">{title}</h1>
      {subtitle && <p className="page-banner__subtitle">{subtitle}</p>}
      {breadcrumbs.length > 0 && (
        <nav className="page-banner__breadcrumbs">
          <Link to="/">Home</Link>
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              <span className="page-banner__sep">/</span>
              {b.path ? <Link to={b.path}>{b.label}</Link> : <span>{b.label}</span>}
            </React.Fragment>
          ))}
        </nav>
      )}
    </div>
  </section>
);

/* ===== Section Header ===== */
export const SectionHeader = ({ label, title, description, light }) => (
  <div className={`section-header ${light ? 'section-header--light' : ''}`}>
    {label && <span className="section-header__label">{label}</span>}
    <h2 className="section-header__title">{title}</h2>
    {description && <p className="section-header__desc">{description}</p>}
  </div>
);

/* ===== Loader ===== */
export const Loader = () => (
  <div className="page-loader">
    <div className="spinner" />
  </div>
);

/* ===== Empty State ===== */
export const EmptyState = ({ icon, title, description }) => (
  <div className="empty-state">
    {icon && <div className="empty-state__icon">{icon}</div>}
    <h3 className="empty-state__title">{title || 'No data found'}</h3>
    {description && <p className="empty-state__desc">{description}</p>}
  </div>
);
